import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-gema-black text-white/40 font-mono text-sm">Verificando sesión…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
